var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcoLocationTrain = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 37,
  height: 44,
  fill: "none",
  viewBox: "0 0 37 44"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_8382_49785)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M18.5 39q14-13.701 14-21.635C32.5 9.431 26.232 3 18.5 3s-14 6.431-14 14.365Q4.5 25.3 18.5 39"
}))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1A1A1A",
  d: "M18.5 39q14-13.701 14-21.635C32.5 9.431 26.232 3 18.5 3s-14 6.431-14 14.365Q4.5 25.3 18.5 39"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M13.776 12.36a2.06 2.06 0 0 1 2.025-1.672h5.397c.263 0 .516.049.749.14a.56.56 0 0 1 .514.291c.386.299.665.733.763 1.241l1.501 7.804a2.814 2.814 0 0 1-2.15 3.278l1.385 1.385a.563.563 0 0 1-.795.795l-.445-.444h-8.44l-.445.444a.563.563 0 0 1-.795-.795l1.385-1.385a2.814 2.814 0 0 1-2.15-3.278zm2.025-.547h4.949l-5.625 5.624h-1.18l.936-4.864a.94.94 0 0 1 .92-.76m7.254 5.624-.936-4.864a.9.9 0 0 0-.163-.376l-5.24 5.24zm-7.345 6.31a.56.56 0 0 0 .142-.24h5.296a.56.56 0 0 0 .142.24l.305.306h-6.19zm3.727-3.222a.937.937 0 1 1-1.875 0 .937.937 0 0 1 1.875 0",
  clipRule: "evenodd"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_8382_49785",
  width: 36,
  height: 44,
  x: 0.5,
  y: 0,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_8382_49785"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_8382_49785",
  result: "shape"
})))));
export default SvgIcoLocationTrain;